// extracted by mini-css-extract-plugin
export default {"empty-container":"Empty_empty-container__9DBzy","empty-logo":"Empty_empty-logo__tQp9e","empty-text":"Empty_empty-text__bi11b"};